interface SystemSourceNodeData {
  tool?: {
    sourceAnnotationNodeId?: unknown;
    sourceCropNodeId?: unknown;
    sourceDirectorConsoleNodeId?: unknown;
    sourceGridSplitNodeId?: unknown;
    sourceImageTransformNodeId?: unknown;
    sourcePanoramaViewNodeId?: unknown;
  };
}

/**
 * 读取系统生成用户素材的来源节点 ID，这类素材保留唯一的系统来源线。
 */
export function getSystemSourceNodeId(data: unknown): string | undefined {
  const tool = (data as SystemSourceNodeData | undefined)?.tool;
  const sourceNodeId = tool?.sourceGridSplitNodeId
    ?? tool?.sourceImageTransformNodeId
    ?? tool?.sourceCropNodeId
    ?? tool?.sourceDirectorConsoleNodeId
    ?? tool?.sourcePanoramaViewNodeId
    ?? tool?.sourceAnnotationNodeId;
  return typeof sourceNodeId === 'string' && sourceNodeId ? sourceNodeId : undefined;
}

/** 用户上传节点不接受输入；系统生成素材保留可见来源端口用于展示既有连线。 */
export function shouldRenderNodeInputPort(data: unknown, showPorts: boolean): boolean {
  if (!showPorts) return false;
  const isCustomer = Boolean((data as { isCustomer?: unknown; } | undefined)?.isCustomer);
  return !isCustomer || Boolean(getSystemSourceNodeId(data));
}

/**
 * 标注结果节点在通用发送事件中固定标记为 label_edit，其它来源不占用该字段。
 */
export function getAnnotationWorkflowToolsName(data: unknown): 'label_edit' | '' {
  const sourceNodeId = (data as SystemSourceNodeData | undefined)?.tool?.sourceAnnotationNodeId;
  return typeof sourceNodeId === 'string' && sourceNodeId ? 'label_edit' : '';
}
